import { render } from "./ContactBody.vue?vue&type=template&id=22cab78e&scoped=true"
import script from "./ContactBody.vue?vue&type=script&lang=js"
export * from "./ContactBody.vue?vue&type=script&lang=js"

import "./ContactBody.vue?vue&type=style&index=0&id=22cab78e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cab78e"]])

export default __exports__